import DesignTokens from '@tableau/design-tokens';
import { cssRule } from 'typestyle';

import { applyColor }from '~src/style/ColorService';

cssRule('.tb-data-grid', {
    cursor: 'default',
    backgroundColor: applyColor(DesignTokens.color.elevation.surface.default.default, '#fff'),
});

cssRule('th', {
    textAlign: 'left',
});

cssRule('.tb-static-grid-table', {
    borderSpacing: 0,
    textAlign: 'left',
    backgroundColor: applyColor(DesignTokens.color.elevation.surface.default.default, '#fff'),
    cursor: 'default',
});

cssRule('.tb-static-grid-table th', {
    fontWeight: 'normal',
    backgroundColor: applyColor(DesignTokens.color.elevation.surface.default.subtle, '#FAFAFA'),
    color: applyColor(DesignTokens.color.font.default.default, '#333'),
});

cssRule('.tb-static-grid-table th.tb-data-grid-headers-line-multiline', {
    paddingTop: '6px',
});

cssRule('.tb-static-grid-table th.tb-data-grid-headers-line-multiline .tb-data-grid-header-text', {
    paddingBottom: '6px',
});

cssRule('.tb-static-grid-table td', {
    padding: 0,
});

cssRule('.tb-data-grid-headers-line', {
    height: '37px',
    borderTop: '1px solid ' + applyColor(DesignTokens.color.elevation.border.default.subtle, '#E6E6E6'),
    borderBottom: '1px solid ' + applyColor(DesignTokens.color.elevation.border.default.subtle, '#E6E6E6'),
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    backgroundColor: applyColor(DesignTokens.color.elevation.surface.default.default, '#fff'),
});

cssRule('.tb-data-grid-headers-line', {
    minWidth: '65px',
});

cssRule('.tb-data-grid-headers', {
    display: 'inline-block',
    verticalAlign: 'top',
});

cssRule('.tb-data-grid-header', {
    display: 'inline-block',
    verticalAlign: 'top',
    height: '37px',
    position: 'relative',
    whiteSpace: 'nowrap',
    color: applyColor(DesignTokens.color.font.default.default, '#333'),
});

cssRule('.tb-data-grid-header-cell.tb-clickable', {
    cursor: 'pointer',
});

cssRule('.tb-data-grid-header-cell.tb-clickable:hover', {
    textDecoration: 'underline',
});

cssRule('.tb-data-grid-header-content', {
    height: '37px',
    lineHeight: '37px',
});

cssRule('.tb-data-grid-header-content-numeric', {
    textAlign: 'right',
});

cssRule('.tb-data-grid-header-content-icon', {
    textAlign: 'center',
});

cssRule('.tb-data-grid-header-text', {
    fontSize: '13px',
    fontWeight: 'bold',
    paddingLeft: '12px',
    paddingRight: '12px',
    backgroundSize: '19px 19px',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: '-5px center',
});

cssRule('.tb-data-grid-header-text.tb-sort-asc', {
    backgroundImage: 'url(img/sort_arrow_ascending.svg?1_0_9606_yabs0uv7t1h)',
});

cssRule('.tb-data-grid-header-text.tb-sort-desc', {
    backgroundImage: 'url(img/sort_arrow_descending.svg?1_0_9606_yabs0uv7t1h)',
});

cssRule('.tb-data-grid-header-text', {
    fontSize: '13px',
    fontWeight: 'bold',
    paddingLeft: '12px',
    paddingRight: '12px',
    backgroundSize: '19px 19px',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: '-5px center',
});

cssRule('.tb-data-grid-header-text.tb-sort-asc', {
    backgroundImage: 'url(img/sort_arrow_ascending.svg?1_0_9606_yabs0uv7t1h)',
});

cssRule('.tb-data-grid-header-text.tb-sort-desc', {
    backgroundImage: 'url(img/sort_arrow_descending.svg?1_0_9606_yabs0uv7t1h)',
});

cssRule('.tb-data-grid-licenses-header-text-multiline', {
    whiteSpace: 'normal',
    fontSize: '13px',
    fontWeight: 'bold',
    backgroundSize: '19px 19px',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: '-5px center',
});

cssRule('.tb-data-grid-licenses-header-text-multiline.tb-sort-asc', {
    backgroundImage: 'url(img/sort_arrow_ascending.svg?1_0_9606_yabs0uv7t1h)',
});

cssRule('.tb-data-grid-licenses-header-text-multiline.tb-sort-desc', {
    backgroundImage: 'url(img/sort_arrow_descending.svg?1_0_9606_yabs0uv7t1h)',
});

cssRule('.tb-data-grid-body', {
    top: 0,
});

cssRule('.tb-data-grid-body.tb-data-grid-has-headers', {
    top: '39px',
});

cssRule('.tb-data-grid-body-columns', {
    position: 'relative',
    display: 'inline-block',
    whiteSpace: 'nowrap',
    '-webkit-tap-highlight-color': 'rgba(0,0,0,0)',
});

cssRule('.tb-data-grid-body-background', {
    position: 'absolute',
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
});

cssRule('.tb-data-grid-row-background', {
    height: '37px',
    borderBottom: '1px solid ' + applyColor(DesignTokens.color.elevation.border.default.clear, '#fff'),
});

cssRule('.tb-show-lines .tb-data-grid-row-background, .tb-data-grid-separator-row', {
    borderBottom: '1px solid ' + applyColor(DesignTokens.color.elevation.border.default.subtle, '#E6E6E6'),
});

cssRule('.tb-data-grid-body-column', {
    display: 'inline-block',
    position: 'relative',
    verticalAlign: 'top',
});

cssRule('.tb-data-grid-cell', {
    height: '37px',
    borderBottom: '1px solid transparent',
});

cssRule('.tb-data-grid-cell-text', {
    color: applyColor(DesignTokens.color.font.default.default, '#2e2e2e'),
    height: '37px',
    lineHeight: '37px',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
});

cssRule('.tb-data-grid-cell-text a.tb-disabled, .tb-details-value a.tb-disabled', {
    color: applyColor(DesignTokens.color.font.default.default, '#2e2e2e'),
});

cssRule('.tb-data-grid-cell-text-numeric', {
    textAlign: 'right',
});

cssRule('.tb-data-grid-cell-text-date', {
    textAlign: 'left',
});

cssRule('.tb-lr-padded-wide-right', {
    paddingRight: '12px',
});

cssRule('.tb-data-grid-cell-text-icon', {
    textAlign: 'center',
    minWidth: '15px',
});

cssRule('.tb-quality-indicator-cell', {
    display: 'inline-block',
    verticalAlign: 'top',
    width: '43px',
    height: '37px',
    paddingTop: '3px',
    textAlign: 'center',
});

cssRule('.tb-data-quality-warning-cell', {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    '-webkit-justify-content': 'center',
    minHeight: '44px',
    height: '100%',
    textAlign: 'center',
});

cssRule('.tb-data-grid-icon', {
    backgroundPosition: 'center',
    verticalAlign: 'top',
    minWidth: '15px',
    height: '37px !important',
});

cssRule('.tb-data-grid-header-icon', {
    backgroundPosition: 'center',
    verticalAlign: 'top',
    minWidth: '15px',
    height: '37px !important',
});

cssRule('.tb-data-grid-column-divider', {
    position: 'absolute',
    top: 0,
    right: 0,
    bottom: 0,
    width: '8px',
    cursor: 'col-resize',
});

cssRule('.tb-data-grid-current-row', {
    backgroundColor: applyColor(DesignTokens.color.elevation.surface.default.subtle, '#F5F5F5'),
});

cssRule('.tb-data-grid-hover-row', {
    backgroundColor: applyColor(DesignTokens.color.elevation.surface.default.subtle, '#F5F5F5'),
});

cssRule('.tb-data-grid-active-row', {
    backgroundColor: applyColor(DesignTokens.color.component.background.neutral.default.active, '#e6e6e6'),
});

cssRule('.tb-data-grid-selected-row', {
    backgroundColor: applyColor(DesignTokens.color.component.background.header.default.info, '#d4e1ed'),
});

cssRule('.tb-highlight-current-row .tb-data-grid-hover-row', {
    backgroundColor: applyColor(DesignTokens.color.elevation.surface.default.subtle, '#F5F5F5'),
});

cssRule('.tb-highlight-current-row .tb-data-grid-current-row', {
    backgroundColor: applyColor(DesignTokens.color.component.background.header.default.info, '#d4e1ed'),
});

cssRule('.tb-highlight-current-row .tb-data-grid-active-row', {
    backgroundColor: applyColor(DesignTokens.color.component.background.neutral.default.active, '#e6e6e6'),
});

cssRule('.tb-highlight-current-row .tb-data-grid-selected-row', {
    backgroundColor: applyColor(DesignTokens.color.component.background.header.default.info, '#d4e1ed'),
});

cssRule('.tb-hide-current-row .tb-data-grid-current-row', {
    backgroundColor: 'transparent',
});

cssRule('.tb-hide-current-row .tb-data-grid-hover-row', {
    backgroundColor: applyColor(DesignTokens.color.elevation.surface.default.subtle, '#F5F5F5'),
});

cssRule('.tb-hide-current-row .tb-data-grid-active-row', {
    backgroundColor: applyColor(DesignTokens.color.component.background.neutral.default.active, '#e6e6e6'),
});

cssRule('.tb-hide-current-row .tb-data-grid-selected-row', {
    backgroundColor: applyColor(DesignTokens.color.component.background.header.default.info, '#d4e1ed'),
});

cssRule('.tb-data-grid-no-matching-results', {
    fontSize: '15px',
    marginTop: '18px',
    padding: '6px',
    lineHeight: '23px',
    textAlign: 'center',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
});

cssRule('.tb-data-grid-no-matching-results a', {
    fontSize: '11px',
});

cssRule('.tb-data-grid-empty', {
    textAlign: 'center',
    marginLeft: 'auto',
    marginRight: 'auto',
    width: '600px',
});

cssRule('.tb-data-grid-empty .tb-data-grid-empty-title', {
    fontWeight: 'normal',
    fontSize: '18px',
    color: applyColor(DesignTokens.color.font.default.secondary, '#4e4e4e'),
    paddingTop: '48px',
    paddingBottom: '32px',
});

cssRule('.tb-data-grid-empty .tb-data-grid-empty-body', {
    fontSize: '13px',
    paddingBottom: '18px',
});

cssRule('.tb-data-grid-empty .tb-data-grid-empty-body-paragraph', {
    textAlign: 'left',
    paddingBottom: '12px',
});

cssRule('.tb-data-grid-empty .tb-data-grid-empty-help-link', {
    fontSize: '13px',
});

cssRule('.tb-site-membership-grid-empty', {
    textAlign: 'center',
    marginLeft: 'auto',
    marginRight: 'auto',
});

cssRule('.tb-site-membership-grid-empty .tb-data-grid-empty-title', {
    fontWeight: 'normal',
    fontSize: '18px',
    color: applyColor(DesignTokens.color.font.default.secondary, '#4e4e4e'),
    paddingTop: '48px',
    paddingBottom: '32px',
});

cssRule('.tb-site-membership-grid-empty .tb-data-grid-empty-body', {
    fontSize: '13px',
    paddingBottom: '18px',
});

cssRule('.tb-site-membership-grid-empty .tb-data-grid-empty-body-paragraph', {
    textAlign: 'left',
    paddingBottom: '12px',
});

cssRule('.tb-site-membership-grid-empty .tb-data-grid-empty-help-link', {
    fontSize: '13px',
});

cssRule('.tb-data-grid-margin-left .tb-data-grid-headers', {
    marginLeft: '12px',
});

cssRule('.tb-data-grid-margin-left .tb-data-grid-body-columns', {
    marginLeft: '12px',
});

cssRule('.tb-data-grid-dialog-tooltip-link', {
    fontFamily: 'BentonSans-BookItalic, Arial, Helvetica, sans-serif',
});

cssRule('.tb-data-grid-dialog-tooltip-link:hover', {
    textDecoration: 'underline !important',
});

cssRule('#interactive-tooltip-Dialog-Body-Id', {
    padding: '0px !important',
});

